import { cn } from '../lib/cn';

/**
 * Symbol Fravity (Figma, strona Brand: Logo/Symbol, Style=Cobalt; ścieżki 1:1 z eksportu Figmy).
 * Górna część: accent/primary (#2B3BFF), dolna: cobalt-ink/300 (#6B78FF).
 * Grafika dekoracyjna; z `title` dostaje nazwę dla czytników ekranu.
 */
export function LogoSymbol({ size = 20, className, title }: { size?: number; className?: string; title?: string }) {
  const svg = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('shrink-0', className)}
      aria-hidden="true"
    >
      <path d="M27.43 6H107.9L92.57 25.16H37.01L12.1 56.3V25.16L27.43 6Z" fill="var(--accent-primary)" />
      <path d="M42.03 35.61H92.23L76.9 54.77H59.48L12.1 114V73.03L42.03 35.61Z" fill="var(--accent-secondary)" />
    </svg>
  );
  if (!title) return svg;
  return (
    <span role="img" aria-label={title} className="inline-flex shrink-0">
      {svg}
    </span>
  );
}

/** Symbol + nazwa produktu (ekrany logowania). */
export function LogoLockup({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <LogoSymbol size={28} />
      <span className="text-[17px] leading-none font-semibold tracking-[-0.01em] text-fg">Fravity OS</span>
    </span>
  );
}
